var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Write × AI / User Interface Experiment / v1.99 / "),_c('vs-button',{staticClass:"button-link",attrs:{"transparent":"","size":"large","href":"https://tmat.me"}},[_vm._v("Artyom")]),_vm._v(" made this.")],1)}
var staticRenderFns = []

export { render, staticRenderFns }